import {atom, useAtom} from 'jotai';
import type {MeetingType} from '@entities/meeting/model/types';

/**
 * Состояние фильтров на странице «Встречи».
 * `type` — выбранный таб: 'all' (Все) / 'offline' (Очные) / 'online' (Онлайн).
 */
export interface MeetingsFilterState {
  managerId?: string;
  type: 'all' | MeetingType;
  /** Тип коммуникации (`result.callType`, значения — из планов встреч). */
  callType?: string;
  search: string;
  /** MQL-путь поля, по которому ищем (contains). */
  searchField: string;
}

const initial: MeetingsFilterState = {
  search: '',
  type: 'all',
  searchField: 'communicationId',
};

/** Atom состояния фильтров (живёт между переходами между страницами). */
export const meetingsFilterAtom = atom<MeetingsFilterState>(initial);

/** Хук-обёртка для удобной работы с фильтрами. */
export const useMeetingsFilter = () => {
  const [filter, setFilter] = useAtom(meetingsFilterAtom);

  return {
    filter,
    setManagerId: (managerId?: string) => setFilter((p) => ({...p, managerId})),
    setType: (type: MeetingsFilterState['type']) =>
      setFilter((p) => ({...p, type})),
    setCallType: (callType?: string) => setFilter((p) => ({...p, callType})),
    setSearch: (search: string) => setFilter((p) => ({...p, search})),
    setSearchField: (searchField: string) =>
      setFilter((p) => ({...p, searchField, search: ''})),
    reset: () => setFilter(initial),
  };
};
